import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Dropdown, DropdownButton, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { BiCalendar, BiXCircle } from "react-icons/bi";
import DateTimePicker from 'react-datetime-picker';
import { axiosAuth_PLATFORM_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';


const DeviceAdmin_NewDeviceView = (props) => {

  // Utilities
  const { i18n, t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [deviceAttrs, setDeviceAttrs] = useState({
    name: '',
    type: '',
    description: '',
    assetCode: '',
    status: 'OFFLINE',
    location: '',
    mfr: '',
    model: '',
    serialNum: '',
    mfrDate: '',
    installDate: '',
    fwVersion: '',
    dataType: '',
    authMethod: '',
    currNetwk: '',
    allowedNetwks: '',
    allowedApps: '',
    updatedBy: '',
    timeUpdated: '',
    createdBy: '',
    timeCreated: ''
  });

  const [mfrDate,     setMfrDate]     = useState(null);
  const [installDate, setInstallDate] = useState(null);

  // UI Functions

  const [errMsg, setErrMsg] = useState('');

/*
  const deviceTypeList = [
    { key: "EG_CTRLR",        value: "EG_CTRLR" },
    { key: "C100",            value: "C100" },
    { key: "TEMP_SNSR",       value: "TEMP_SNSR" },
    { key: "HUM_SNSR",        value: "HUM_SNSR" },
    { key: "VOLT_SNSR",       value: "VOLT_SNSR" },
    { key: "AMP_SNSR",        value: "AMP_SNSR" },
    { key: "WATER_LV_SNSR",   value: "WATER_LV_SNSR" },
    { key: "PM2.5_SNSR",      value: "PM2.5_SNSR" }
  ];
*/

  const deviceStatusList = [
    { key: "NORMAL",         value: "NORMAL" },
    { key: "FAULT",          value: "FAULT" },
    { key: "OFFLINE",        value: "OFFLINE" },
    { key: "DECOMM",         value: "DECOMM" }
  ];

  const dataTypeList = [
    { key: "INT",    value: "INT" },
    { key: "FLOAT",  value: "FLOAT" },
    { key: "STRING", value: "STRING" },
    { key: "JSON",   value: "JSON" },
    { key: "MULTI",   value: "MULTI" }
  ];

  const authMethodList = [
    { key: "API",    value: "API" },
    { key: "CERT",   value: "CERT" },
    { key: "DEVICE", value: "DEVICE" }
/*
    { key: "OAUTH",  value: "OAUTH" }
*/
  ];


  const onAttrsInputChange = (e) => {
    setDeviceAttrs({ ...deviceAttrs, [e.target.name]: e.target.value })
  }

  const onDatepickerChangeMfrDate = (value) => {
    setMfrDate(value);
  }

  const onDatepickerChangeInstallDate = (value) => {
    setInstallDate(value);
  }

/*
  const onDeviceTypeSelect = (key, event) => {
    setDeviceAttrs({ ...deviceAttrs, type: key })
  };
*/

  const onDeviceStatusSelect = (key, event) => {
    setDeviceAttrs({ ...deviceAttrs, status: key })
  };

  const onDataTypeSelect = (key, event) => {
    setDeviceAttrs({ ...deviceAttrs, dataType: key })
  };

  const onAuthMethodSelect = (key, event) => {
    setDeviceAttrs({ ...deviceAttrs, authMethod: key })
  };


  const handleGenKeyNSecret = () => {
    new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("gen-random-key-secret/128");

        resolve(res.data);

        if (res.status === 200) {
          // Deep copy
          let tmpAttrs = JSON.parse(JSON.stringify(deviceAttrs));

          tmpAttrs.deviceCert   = res.data.key;
          tmpAttrs.deviceSecret = res.data.secret;

          setDeviceAttrs(tmpAttrs);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });

    return;
  }

  const handleClearCertNSecret = () => {
    // Deep copy
    let tmpAttrs = JSON.parse(JSON.stringify(deviceAttrs));

    tmpAttrs.deviceCert    = ""
    tmpAttrs.deviceSecret = ""

    setDeviceAttrs(tmpAttrs);
  }


  const handleSubmit = (e) => {
    e.preventDefault();

    if (!deviceAttrs.name || deviceAttrs.name.length === 0) {
      setErrMsg(t("I18N_ERR_Need_devname"));
    } else {
      validateDeviceName();
    }

    return;
  }

  // Since this is async, need to call this first, and check the others when username availability returns
  function validateDeviceName() {

    new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.head("devicename/" + deviceAttrs.name);

        resolve(res.data);

        if (res.status === 200) {
          // Device name is taken
          setErrMsg(t("I18N_ERR_Dup_name"));
          return;
        } else {
          validateOtherFields();
          return;
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
          validateOtherFields();
        }
        return;
      }
    });
  }

  function validateOtherFields() {
    // Validate form inputs
    if (deviceAttrs.type === '') {
      setErrMsg(t("I18N_ERR_Need_devtype"));
    } else if (deviceAttrs.status === '') {
      setErrMsg(t("I18N_ERR_Need_status"));
    } else if (!deviceAttrs.mfr || deviceAttrs.mfr.length === 0) {
      setErrMsg(t("I18N_ERR_Need_mfr"));
    } else if (!deviceAttrs.model || deviceAttrs.model.length === 0) {
      setErrMsg(t("I18N_ERR_Need_model"));
    } else if (!deviceAttrs.serialNum || deviceAttrs.serialNum.length === 0) {
      setErrMsg(t("I18N_ERR_Need_serial_num"));
    } else {
      setErrMsg('');
      createNewDevice();
    }
  }

  const createNewDevice = () => {

    // Make a deep copy
    const reqBody = JSON.parse(JSON.stringify(deviceAttrs));

    reqBody.mfrDate     = (mfrDate     ? mfrDate.toISOString()  : "");
    reqBody.installDate = (installDate ? installDate.toISOString() : "");

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.post("devices", reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          navigate(-1);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleCancel = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_New_device")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Device_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
        </div>

        <Container>
          <form>
            <Row className={classes.admin_pages__field_label}>
              <Col>{t("I18N_Device_name")}: *</Col>
              <Col>{t("I18N_Device_type")}: *</Col>
              <Col>{t("I18N_Asset_code")}:</Col>
              <Col></Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col>
                <input className={classes.admin_pages__field_editable} name="name" value={deviceAttrs.name}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
{/*
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={(deviceAttrs.type === "") ? t("common:I18N_DROPDOWN_PROMPT") : t("custom:I18N_DEVTYPE_" + deviceAttrs.type)}
                  onSelect={onDeviceTypeSelect}>
                  {deviceTypeList.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                        {t("custom:I18N_DEVTYPE_" + item.value)}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
*/}
                <input className={classes.admin_pages__field_editable} name="type" value={deviceAttrs.type}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <input className={classes.admin_pages__field_editable} name="assetCode" value={deviceAttrs.assetCode}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col></Col>
            </Row>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              <Col>{t("I18N_Status")}: *</Col>
              <Col>{t("I18N_Device_loc")}:</Col>
              <Col>{t("I18N_Description")}:</Col>
              <Col></Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={t("common:I18N_DEV_ST_" + deviceAttrs.status)}
                  onSelect={onDeviceStatusSelect}>
                  {deviceStatusList.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                        {t("common:I18N_DEV_ST_" + item.value)}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Col>
              <Col>
                <input className={classes.admin_pages__field_editable} name="location" value={deviceAttrs.location}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <textarea className={classes.admin_pages__field_editable} name="description" value={deviceAttrs.description}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col></Col>
            </Row>

            <Row className={classes.admin_pages__field_label}>
              <Col>{t("I18N_Mfr")}: *</Col>
              <Col>{t("I18N_Model")}: *</Col>
              <Col>{t("I18N_Serial_num")}: *</Col>
              <Col>{t("I18N_Mfr_date")}:</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col>
                <input className={classes.admin_pages__field_editable} name="mfr" value={deviceAttrs.mfr}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <input className={classes.admin_pages__field_editable} name="model" value={deviceAttrs.model}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <input className={classes.admin_pages__field_editable} name="serialNum" value={deviceAttrs.serialNum}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <DateTimePicker onChange={onDatepickerChangeMfrDate} value={mfrDate}
                  format={ (mfrDate != null) ? "y-MM-dd" : "y-MM-dd" }
                  disableClock="true"
                  clearIcon=<BiXCircle size={16} style={{color:"gray"}}/>
                  calendarIcon=<BiCalendar size={16} style={{color:"gray"}}/>
                  locale={i18n.language === 'zh_HK' ? "zh-HK" : (i18n.language === 'zh_CN' ? "zh-CN" : "en")}
                />
              </Col>
            </Row>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              <Col>{t("I18N_Install_date")}:</Col>
              <Col>{t("I18N_Fw_ver")}:</Col>
              <Col>{t("I18N_Data_type")}:</Col>
              <Col></Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col>
                <DateTimePicker onChange={onDatepickerChangeInstallDate} value={installDate}
                  format={ (installDate != null) ? "y-MM-dd" : "y-MM-dd" }
                  disableClock="true"
                  clearIcon=<BiXCircle size={16} style={{color:"gray"}}/>
                  calendarIcon=<BiCalendar size={16} style={{color:"gray"}}/>
                  locale={i18n.language === 'zh_HK' ? "zh-HK" : (i18n.language === 'zh_CN' ? "zh-CN" : "en")}
                />
              </Col>
              <Col>
                <input className={classes.admin_pages__field_editable} name="fwVersion" value={deviceAttrs.fwVersion}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={(deviceAttrs.dataType === "") ? t("common:I18N_DROPDOWN_PROMPT") : t("I18N_DATATYPE_" + deviceAttrs.dataType)}
                  onSelect={onDataTypeSelect}>
                  {dataTypeList.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                        {t("I18N_DATATYPE_" + item.value)}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Col>
              <Col></Col>
            </Row>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              <Col>{t("I18N_Auth_method")}:</Col>
              <Col>{t("I18N_Curr_netwk")}:</Col>
              <Col>{t("I18N_Allowed_netwks")}:</Col>
              <Col>{t("I18N_Allowed_apps")}:</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={(deviceAttrs.authMethod === "") ? t("common:I18N_DROPDOWN_PROMPT") : t("I18N_AUTH_" + deviceAttrs.authMethod)}
                  onSelect={onAuthMethodSelect}>
                  {authMethodList.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                        {t("I18N_AUTH_" + item.value)}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Col>
              <Col>
                <input className={classes.admin_pages__field_editable} name="currNetwk" value={deviceAttrs.currNetwk}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <input className={classes.admin_pages__field_editable} name="allowedNetwks" value={deviceAttrs.allowedNetwks}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <input className={classes.admin_pages__field_editable} name="allowedApps" value={deviceAttrs.allowedApps}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
            </Row>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              <Col></Col>
              <Col>{t("I18N_Device_cert")}:</Col>
              <Col>{t("I18N_Device_secret")}:</Col>
              <Col></Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col>
                <Button size="tiny" variant="outline-secondary" className="mb-3"
                  style={{ float: 'left' }}
                  onClick={handleGenKeyNSecret}>
                  {t("I18N_Gen_key_n_secret")}
                </Button>
                <OverlayTrigger overlay={<Tooltip id="tooltip-del_dp" style={{marginLeft:'15px', fontSize:'11px'}}>{t("I18N_TIP_Clear")}</Tooltip>}>
                  <span style={{marginLeft:'10px', cursor:'pointer', color:'gray'}} onClick={() => handleClearCertNSecret()}><BiXCircle size={16} /></span>
                </OverlayTrigger>
              </Col>
              <Col>
                <textarea className={classes.admin_pages__field_editable} disabled={true} style={{minWidth: '100%', minHeight:'120px', backgroundColor:'white'}}
                          name="contactEmail" value={deviceAttrs.deviceCert}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <textarea className={classes.admin_pages__field_editable} disabled={true} style={{minWidth: '100%', minHeight:'120px', backgroundColor:'white'}}
                          name="contactPhone" value={deviceAttrs.deviceSecret}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col></Col>
            </Row>

            <hr className="solid" style={{ marginTop: '30px' }}></hr>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px', fontStyle: 'italic' }}>
              <span>{t("I18N_Req_fields")}</span>
            </Row>

            <Row>
              <div display='flex' style={{ marginTop: '15px' }}>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ float: 'left' }}
                  onClick={handleCancel}>
                  {t("I18N_Cancel")}
                </Button>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ marginLeft: '15px' }}
                  onClick={handleSubmit}>
                  {t("I18N_Submit")}
                </Button>
                <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                  {errMsg}
                </span>
              </div>
            </Row>
          </form>
        </Container>

      </Card>
    </>
  );
}

export default DeviceAdmin_NewDeviceView;
